// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logo-margin {margin-top: 50px; margin-bottom: 30px;}
@media screen and (min-width: 1401px) and (max-width: 8000px)  {
    .login-banner-size { width:50%}

    .dashboard-container { width: 97% !important;}
} 

@media screen and (min-width: 1201px) and (max-width: 1400px)  {
    .login-banner-size { width:50% !important}
    .dashboard-container { width: 95% !important;}
}
@media screen and (min-width: 1025px) and (max-width: 1200px)  {
    .login-banner-size { width:65% !important}

    .dashboard-container { width: 95% !important;}
}

@media screen and (min-width: 992px) and (max-width: 1024px)  {
    .login-banner-size { width:65% !important}

    .dashboard-container { width: 94% !important;}
}

@media screen and (min-width: 768px) and (max-width: 991px)  {
    .login-banner-size { width:45% !important}
    .login-box {margin: auto !important; margin-top: 40px !important; margin-bottom: 40px !important;}

    .dashboard-container { width: 93% !important;}
}

@media screen and (min-width: 601px) and (max-width: 767px)  {
    .login-banner-size { width:50%}
    .login-box {margin: auto !important; margin-top: 40px !important; margin-bottom: 40px !important;}

    .dashboard-container { width: 92% !important;}
}
@media screen and (max-width: 600px) {
    .login-banner-size { width:55%}
    .login-box {margin: auto !important; margin-top: 40px !important;  margin-bottom: 40px !important;}

    .dashboard-container { width: 90% !important;}
}
.login-box input[type='text'],
.login-box input[type='password'] {border-radius: 25px !important;}
.RaLayout-content {display: block !important;}
.contents-main-div { width: calc(100% - 80px) !important; padding: 25px 0px;}

@media screen and (min-width: 600px) and (max-width: 10000px)  {
.RaAppBar-menuButton {display: none !important;}
}

@media (min-width: 0px) and (max-width: 599.95px) {
.css-1fx0p7e-MuiModal-root-MuiDrawer-root-RaSidebar-root .MuiPaper-root {
    margin-top: 0;
    height: 100vh;
    position: inherit;
    background-color: #2b3f7a!important;
    width: 80px !important;
}
}

.left-menu-bg { background-color: #1b3b97 !important;}

.RaMenu-open a:visited,
.RaMenu-open a:hover {color: #fff !important; font-weight: 300 !important;}

.left-menu-link a:link,
.left-menu-link a:visited,
.left-menu-link a:hover {
    color: #fff !important; 
    text-transform: capitalize !important; 
    letter-spacing: 1px; 
    margin-bottom: 2px !important; 
    margin-top: 2px !important; 
}
.RaSidebar-fixed a:hover{color: #fff !important;}

/* CSS for Dashboard stats */
.dashboard-stats-div {
    color: #fff; 
    border-radius: 7px; 
    display:flex; 
    /* margin-top: 5px; 
    margin-bottom: 5px; */
    height: 75px;
    width: 98%;
}
.total-order {background-color: #fdc522;}
.avg-order {background-color: #4c90ff;}
.avg-order-amount {background-color: #ff5a4d;}
.cod-order {background-color: #35da3e;}
.online-order {background-color: #bd2cff;}
.total-order-amount {background-color: #5c82b5;}
.total-order-quantity {background-color: #1ebcdc;}
.distinct-sku-sold {background-color: #ff5897;}
.total-pending-order {background-color: #1AACAC;}
.avg-lines-per-order {background-color: #BE6DB7;}
.total-discount {background-color: #85cc79;}
.order-qty-pending-stock {background-color: #9b9baa;}
.unfulfillable-line-level-order {background-color: #C26DBC;}
.total-unfulfillable-order {background-color: #60A3D9;}
.total-failed-order {background-color: #ff387e;}
.total-sla-breached-order {background-color: #8650ff;}

.stats-label-div {
    float: left; display:block; 
    width: calc(100% - 75px); 
    padding: 12px 15px;
}
.stats-label-div p {
/*  font-size: 14px; */
    text-transform: uppercase; 
    letter-spacing: .2px; 
    margin: 0px;
    padding: 4px 0;
    font-weight: 500;
    line-height: 1;
}
.stats-label-div h3{ margin: 0px;}

@media screen and (min-width: 1801px) and (max-width: 10000px) {
    .stats-desktop-width {width: 20% !important;}
}

@media screen and (min-width: 1451px) and (max-width: 1800px) {
    .stats-desktop-width {width: 25% !important;}
}

@media screen and (min-width: 1024px) and (max-width: 1450px) {
    .stats-desktop-width {width: 33.333% !important;}
}

@media screen and (min-width: 993px) and (max-width: 1023px) {
    .stats-desktop-width {width: 50% !important;}
}

@media screen and (min-width: 601px) and (max-width: 992px) {
    .stats-desktop-width {width: 50% !important;}
}

@media screen and (min-width: 200px) and (max-width: 600px) {
    .stats-desktop-width {width: 100% !important;}
}


@media screen and (min-width: 1250px) and (max-width: 8000px) {
    .stats-label-div p { font-size: 13px !important;}
    .stats-label-div h3{ font-size: 22px;}
}
@media screen and (min-width:1200px) and (max-width:1250px){ 
    .stats-label-div p { font-size: 100% !important;}
    .stats-label-div h3{ font-size: 20px;}
}

@media screen and (max-width:1200px) {
    .stats-label-div p { font-size: 12px !important;} 
    .stats-label-div h3{ font-size: 18px;}
  }

.stats-icon-div {
    display: block; 
    float: right; 
    width: 75px; 
    background-color: rgb(0, 0, 0, 0.07)
}
.stats-icon-div img {
    opacity: 0.5; 
    width: 75px; 
    border-top-right-radius: 7px; 
    border-bottom-right-radius: 7px;
}



.scrollable-div::-webkit-scrollbar {
    background-color: transparent;
    width: 10px;
}
.scrollable-div:hover::-webkit-scrollbar {
    width: 4px;
}   
       
.scrollable-div {
/*  overflow-y: hidden;*/
overflow: hidden;
/* More presentational CSS */
}

.scrollable-div::-webkit-scrollbar {
   width: 4px;
   height: 4px
}
.scrollable-div::-webkit-scrollbar-button {
   background: #eee;
   height: 0px
}
.scrollable-div::-webkit-scrollbar-track-piece {
   background: #eee
}
.scrollable-div::-webkit-scrollbar-thumb {
   background: #999
} 

/* @media screen and (min-width: 600px) and (max-width: 8000px) {
    .MuiDrawer-docked {
        width: 80px;
        height: 100vh;  
        top: 0; 
        display: inline-flex; 
        float: left; 
        padding-top: 60px; 
        position: fixed;
    }
    .main-content {
        width: calc(100% - 80px); 
        display: inline; 
        float: right; 
        margin-top: 60px; 
        margin-left: 80px;
    }
}
@media screen and (max-width:599px){ 
    .MuiDrawer-docked {
        /* width: 80px;
        height: 100vh;  
        top: 0; display: inline-flex; 
        float: left; 
    }
    .main-content {
        width: 100%; 
        display: block; 
        float: right; 
        margin-top: 60px; 
        margin-left: 80px;
    }
} */

.dashboard-select select option {line-height: 24px !important; padding: 20px !important;}

@media screen and (max-width:599px) {
.css-jp2pjq-RaUserMenu-root { width: 100%; float: right;}
}

/* .RaAppBar-toolbar .css-1ghzyfa-RaLoadingIndicator-root { display: 'none !important' }
.RaAppBar-toolbar .css-jp2pjq-RaUserMenu-root{width:'100%'; textAlign:'right'} */
.RaAppBar-toolbar .css-lpub39-RaLoadingIndicator-root { display: none !important }
.RaAppBar-toolbar .css-6u3hli-RaUserMenu-root{width:100% !important; text-align:right !important}
`, "",{"version":3,"sources":["webpack://./src/components/common/styles.css"],"names":[],"mappings":"AAAA,cAAc,gBAAgB,EAAE,mBAAmB,CAAC;AACpD;IACI,qBAAqB,SAAS;;IAE9B,uBAAuB,qBAAqB,CAAC;AACjD;;AAEA;IACI,qBAAqB,oBAAoB;IACzC,uBAAuB,qBAAqB,CAAC;AACjD;AACA;IACI,qBAAqB,oBAAoB;;IAEzC,uBAAuB,qBAAqB,CAAC;AACjD;;AAEA;IACI,qBAAqB,oBAAoB;;IAEzC,uBAAuB,qBAAqB,CAAC;AACjD;;AAEA;IACI,qBAAqB,oBAAoB;IACzC,YAAY,uBAAuB,EAAE,2BAA2B,EAAE,8BAA8B,CAAC;;IAEjG,uBAAuB,qBAAqB,CAAC;AACjD;;AAEA;IACI,qBAAqB,SAAS;IAC9B,YAAY,uBAAuB,EAAE,2BAA2B,EAAE,8BAA8B,CAAC;;IAEjG,uBAAuB,qBAAqB,CAAC;AACjD;AACA;IACI,qBAAqB,SAAS;IAC9B,YAAY,uBAAuB,EAAE,2BAA2B,GAAG,8BAA8B,CAAC;;IAElG,uBAAuB,qBAAqB,CAAC;AACjD;AACA;mCACmC,8BAA8B,CAAC;AAClE,mBAAmB,yBAAyB,CAAC;AAC7C,qBAAqB,mCAAmC,EAAE,iBAAiB,CAAC;;AAE5E;AACA,sBAAsB,wBAAwB,CAAC;AAC/C;;AAEA;AACA;IACI,aAAa;IACb,aAAa;IACb,iBAAiB;IACjB,mCAAmC;IACnC,sBAAsB;AAC1B;AACA;;AAEA,gBAAgB,oCAAoC,CAAC;;AAErD;sBACsB,sBAAsB,EAAE,2BAA2B,CAAC;;AAE1E;;;IAGI,sBAAsB;IACtB,qCAAqC;IACrC,mBAAmB;IACnB,6BAA6B;IAC7B,0BAA0B;AAC9B;AACA,yBAAyB,sBAAsB,CAAC;;AAEhD,4BAA4B;AAC5B;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ;yBACqB;IACrB,YAAY;IACZ,UAAU;AACd;AACA,cAAc,yBAAyB,CAAC;AACxC,YAAY,yBAAyB,CAAC;AACtC,mBAAmB,yBAAyB,CAAC;AAC7C,YAAY,yBAAyB,CAAC;AACtC,eAAe,yBAAyB,CAAC;AACzC,qBAAqB,yBAAyB,CAAC;AAC/C,uBAAuB,yBAAyB,CAAC;AACjD,oBAAoB,yBAAyB,CAAC;AAC9C,sBAAsB,yBAAyB,CAAC;AAChD,sBAAsB,yBAAyB,CAAC;AAChD,iBAAiB,yBAAyB,CAAC;AAC3C,0BAA0B,yBAAyB,CAAC;AACpD,iCAAiC,yBAAyB,CAAC;AAC3D,4BAA4B,yBAAyB,CAAC;AACtD,qBAAqB,yBAAyB,CAAC;AAC/C,2BAA2B,yBAAyB,CAAC;;AAErD;IACI,WAAW,EAAE,aAAa;IAC1B,wBAAwB;IACxB,kBAAkB;AACtB;AACA;AACA,sBAAsB;IAClB,yBAAyB;IACzB,oBAAoB;IACpB,WAAW;IACX,cAAc;IACd,gBAAgB;IAChB,cAAc;AAClB;AACA,qBAAqB,WAAW,CAAC;;AAEjC;IACI,sBAAsB,qBAAqB,CAAC;AAChD;;AAEA;IACI,sBAAsB,qBAAqB,CAAC;AAChD;;AAEA;IACI,sBAAsB,yBAAyB,CAAC;AACpD;;AAEA;IACI,sBAAsB,qBAAqB,CAAC;AAChD;;AAEA;IACI,sBAAsB,qBAAqB,CAAC;AAChD;;AAEA;IACI,sBAAsB,sBAAsB,CAAC;AACjD;;;AAGA;IACI,qBAAqB,0BAA0B,CAAC;IAChD,qBAAqB,eAAe,CAAC;AACzC;AACA;IACI,qBAAqB,0BAA0B,CAAC;IAChD,qBAAqB,eAAe,CAAC;AACzC;;AAEA;IACI,qBAAqB,0BAA0B,CAAC;IAChD,qBAAqB,eAAe,CAAC;EACvC;;AAEF;IACI,cAAc;IACd,YAAY;IACZ,WAAW;IACX;AACJ;AACA;IACI,YAAY;IACZ,WAAW;IACX,4BAA4B;IAC5B,+BAA+B;AACnC;;;;AAIA;IACI,6BAA6B;IAC7B,WAAW;AACf;AACA;IACI,UAAU;AACd;;AAEA;AACA,wBAAwB;AACxB,gBAAgB;AAChB,4BAA4B;AAC5B;;AAEA;GACG,UAAU;GACV;AACH;AACA;GACG,gBAAgB;GAChB;AACH;AACA;GACG;AACH;AACA;GACG;AACH;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAgCG;;AAEH,iCAAiC,4BAA4B,EAAE,wBAAwB,CAAC;;AAExF;AACA,8BAA8B,WAAW,EAAE,YAAY,CAAC;AACxD;;AAEA;gFACgF;AAChF,wDAAwD,yBAAyB;AACjF,8CAA8C,qBAAqB,EAAE,2BAA2B","sourcesContent":[".logo-margin {margin-top: 50px; margin-bottom: 30px;}\n@media screen and (min-width: 1401px) and (max-width: 8000px)  {\n    .login-banner-size { width:50%}\n\n    .dashboard-container { width: 97% !important;}\n} \n\n@media screen and (min-width: 1201px) and (max-width: 1400px)  {\n    .login-banner-size { width:50% !important}\n    .dashboard-container { width: 95% !important;}\n}\n@media screen and (min-width: 1025px) and (max-width: 1200px)  {\n    .login-banner-size { width:65% !important}\n\n    .dashboard-container { width: 95% !important;}\n}\n\n@media screen and (min-width: 992px) and (max-width: 1024px)  {\n    .login-banner-size { width:65% !important}\n\n    .dashboard-container { width: 94% !important;}\n}\n\n@media screen and (min-width: 768px) and (max-width: 991px)  {\n    .login-banner-size { width:45% !important}\n    .login-box {margin: auto !important; margin-top: 40px !important; margin-bottom: 40px !important;}\n\n    .dashboard-container { width: 93% !important;}\n}\n\n@media screen and (min-width: 601px) and (max-width: 767px)  {\n    .login-banner-size { width:50%}\n    .login-box {margin: auto !important; margin-top: 40px !important; margin-bottom: 40px !important;}\n\n    .dashboard-container { width: 92% !important;}\n}\n@media screen and (max-width: 600px) {\n    .login-banner-size { width:55%}\n    .login-box {margin: auto !important; margin-top: 40px !important;  margin-bottom: 40px !important;}\n\n    .dashboard-container { width: 90% !important;}\n}\n.login-box input[type='text'],\n.login-box input[type='password'] {border-radius: 25px !important;}\n.RaLayout-content {display: block !important;}\n.contents-main-div { width: calc(100% - 80px) !important; padding: 25px 0px;}\n\n@media screen and (min-width: 600px) and (max-width: 10000px)  {\n.RaAppBar-menuButton {display: none !important;}\n}\n\n@media (min-width: 0px) and (max-width: 599.95px) {\n.css-1fx0p7e-MuiModal-root-MuiDrawer-root-RaSidebar-root .MuiPaper-root {\n    margin-top: 0;\n    height: 100vh;\n    position: inherit;\n    background-color: #2b3f7a!important;\n    width: 80px !important;\n}\n}\n\n.left-menu-bg { background-color: #1b3b97 !important;}\n\n.RaMenu-open a:visited,\n.RaMenu-open a:hover {color: #fff !important; font-weight: 300 !important;}\n\n.left-menu-link a:link,\n.left-menu-link a:visited,\n.left-menu-link a:hover {\n    color: #fff !important; \n    text-transform: capitalize !important; \n    letter-spacing: 1px; \n    margin-bottom: 2px !important; \n    margin-top: 2px !important; \n}\n.RaSidebar-fixed a:hover{color: #fff !important;}\n\n/* CSS for Dashboard stats */\n.dashboard-stats-div {\n    color: #fff; \n    border-radius: 7px; \n    display:flex; \n    /* margin-top: 5px; \n    margin-bottom: 5px; */\n    height: 75px;\n    width: 98%;\n}\n.total-order {background-color: #fdc522;}\n.avg-order {background-color: #4c90ff;}\n.avg-order-amount {background-color: #ff5a4d;}\n.cod-order {background-color: #35da3e;}\n.online-order {background-color: #bd2cff;}\n.total-order-amount {background-color: #5c82b5;}\n.total-order-quantity {background-color: #1ebcdc;}\n.distinct-sku-sold {background-color: #ff5897;}\n.total-pending-order {background-color: #1AACAC;}\n.avg-lines-per-order {background-color: #BE6DB7;}\n.total-discount {background-color: #85cc79;}\n.order-qty-pending-stock {background-color: #9b9baa;}\n.unfulfillable-line-level-order {background-color: #C26DBC;}\n.total-unfulfillable-order {background-color: #60A3D9;}\n.total-failed-order {background-color: #ff387e;}\n.total-sla-breached-order {background-color: #8650ff;}\n\n.stats-label-div {\n    float: left; display:block; \n    width: calc(100% - 75px); \n    padding: 12px 15px;\n}\n.stats-label-div p {\n/*  font-size: 14px; */\n    text-transform: uppercase; \n    letter-spacing: .2px; \n    margin: 0px;\n    padding: 4px 0;\n    font-weight: 500;\n    line-height: 1;\n}\n.stats-label-div h3{ margin: 0px;}\n\n@media screen and (min-width: 1801px) and (max-width: 10000px) {\n    .stats-desktop-width {width: 20% !important;}\n}\n\n@media screen and (min-width: 1451px) and (max-width: 1800px) {\n    .stats-desktop-width {width: 25% !important;}\n}\n\n@media screen and (min-width: 1024px) and (max-width: 1450px) {\n    .stats-desktop-width {width: 33.333% !important;}\n}\n\n@media screen and (min-width: 993px) and (max-width: 1023px) {\n    .stats-desktop-width {width: 50% !important;}\n}\n\n@media screen and (min-width: 601px) and (max-width: 992px) {\n    .stats-desktop-width {width: 50% !important;}\n}\n\n@media screen and (min-width: 200px) and (max-width: 600px) {\n    .stats-desktop-width {width: 100% !important;}\n}\n\n\n@media screen and (min-width: 1250px) and (max-width: 8000px) {\n    .stats-label-div p { font-size: 13px !important;}\n    .stats-label-div h3{ font-size: 22px;}\n}\n@media screen and (min-width:1200px) and (max-width:1250px){ \n    .stats-label-div p { font-size: 100% !important;}\n    .stats-label-div h3{ font-size: 20px;}\n}\n\n@media screen and (max-width:1200px) {\n    .stats-label-div p { font-size: 12px !important;} \n    .stats-label-div h3{ font-size: 18px;}\n  }\n\n.stats-icon-div {\n    display: block; \n    float: right; \n    width: 75px; \n    background-color: rgb(0, 0, 0, 0.07)\n}\n.stats-icon-div img {\n    opacity: 0.5; \n    width: 75px; \n    border-top-right-radius: 7px; \n    border-bottom-right-radius: 7px;\n}\n\n\n\n.scrollable-div::-webkit-scrollbar {\n    background-color: transparent;\n    width: 10px;\n}\n.scrollable-div:hover::-webkit-scrollbar {\n    width: 4px;\n}   \n       \n.scrollable-div {\n/*  overflow-y: hidden;*/\noverflow: hidden;\n/* More presentational CSS */\n}\n\n.scrollable-div::-webkit-scrollbar {\n   width: 4px;\n   height: 4px\n}\n.scrollable-div::-webkit-scrollbar-button {\n   background: #eee;\n   height: 0px\n}\n.scrollable-div::-webkit-scrollbar-track-piece {\n   background: #eee\n}\n.scrollable-div::-webkit-scrollbar-thumb {\n   background: #999\n} \n\n/* @media screen and (min-width: 600px) and (max-width: 8000px) {\n    .MuiDrawer-docked {\n        width: 80px;\n        height: 100vh;  \n        top: 0; \n        display: inline-flex; \n        float: left; \n        padding-top: 60px; \n        position: fixed;\n    }\n    .main-content {\n        width: calc(100% - 80px); \n        display: inline; \n        float: right; \n        margin-top: 60px; \n        margin-left: 80px;\n    }\n}\n@media screen and (max-width:599px){ \n    .MuiDrawer-docked {\n        /* width: 80px;\n        height: 100vh;  \n        top: 0; display: inline-flex; \n        float: left; \n    }\n    .main-content {\n        width: 100%; \n        display: block; \n        float: right; \n        margin-top: 60px; \n        margin-left: 80px;\n    }\n} */\n\n.dashboard-select select option {line-height: 24px !important; padding: 20px !important;}\n\n@media screen and (max-width:599px) {\n.css-jp2pjq-RaUserMenu-root { width: 100%; float: right;}\n}\n\n/* .RaAppBar-toolbar .css-1ghzyfa-RaLoadingIndicator-root { display: 'none !important' }\n.RaAppBar-toolbar .css-jp2pjq-RaUserMenu-root{width:'100%'; textAlign:'right'} */\n.RaAppBar-toolbar .css-lpub39-RaLoadingIndicator-root { display: none !important }\n.RaAppBar-toolbar .css-6u3hli-RaUserMenu-root{width:100% !important; text-align:right !important}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
